import {
  FilterDto,
  MemberStatusDto,
  UserDto,
  UserForGeoMapDto,
} from '@act/shared/data-transfer-objects';
import { userIsMember } from '@act/shared/definitions';
import { EntityId, createEntityAdapter } from '@reduxjs/toolkit';
import { MemberState } from '../types/membersTypes';

export const memberEntityAdapter = createEntityAdapter<UserDto>();
export const memberForMapEntityAdapter =
  createEntityAdapter<UserForGeoMapDto>();
export const memberStatusEntityAdapter = createEntityAdapter<MemberStatusDto>();
export const paginatedMemberEntityAdapter = createEntityAdapter<UserDto>();
export const filterEntityAdapter = createEntityAdapter<FilterDto, EntityId>({
  selectId: filter => filter.key,
});

export const initialMemberState: MemberState = {
  status: 'initial',
  members: memberEntityAdapter.getInitialState(),
  membersForMap: memberForMapEntityAdapter.getInitialState(),
  paginatedMembers: paginatedMemberEntityAdapter.getInitialState(),
  memberStatuses: memberStatusEntityAdapter.getInitialState(),
  count: null,
  filters: [],
};

export const addMembersOnly = (state: MemberState, users: UserDto[]) => {
  const toAdd = [];
  for (const user of users) {
    if (userIsMember(user)) {
      toAdd.push(user);
    }
  }
  memberEntityAdapter.addMany(state.members, toAdd);
};
